import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import SectionPage from "@/pages/SectionPage";
import SubPage from "@/pages/SubPage";
import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Contacto from "@/pages/Contacto";
import QuienesSomos from "@/pages/QuienesSomos";
import NuestrosConsejos from "@/pages/NuestrosConsejos";
import DirectoraDetail from "@/pages/DirectoraDetail";
import JuvenilDetail from "@/pages/JuvenilDetail";
import Alianzas from "@/pages/Alianzas";
import ProgramaPage from "@/pages/ProgramaPage";
import Laboratorio from "@/pages/Laboratorio";
import Informes from "@/pages/Informes";
import ComoAbrirClub from "@/pages/ComoAbrirClub";
import Faqs from "@/pages/Faqs";
import TransicionLiderazgos from "@/pages/TransicionLiderazgos";
import DirectorioClubs from "@/pages/DirectorioClubs";
import ProgramaAcompanamiento from "@/pages/ProgramaAcompanamiento";
import ClubsPrograma from "@/pages/ClubsPrograma";
import DonaAhora from "@/pages/DonaAhora";
import TejiendoRedes from "@/pages/TejiendoRedes";
import ElJardin from "@/pages/ElJardin";
import RecursosArchive from "@/pages/RecursosArchive";
import EquipoDetail from "@/pages/EquipoDetail";
import { SECTIONS } from "@/data/siteContent";

const Site = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/contacto" element={<Site><Contacto /></Site>} />
          <Route path="/conocenos/quienes-somos" element={<Site><QuienesSomos /></Site>} />
          <Route path="/conocenos/alianzas" element={<Site><Alianzas /></Site>} />
          <Route path="/programas/stem-bienestar" element={<Site><ProgramaPage slug="stem-bienestar" /></Site>} />
          <Route path="/programas/escuela-de-formacion" element={<Site><ProgramaPage slug="escuela-de-formacion" /></Site>} />
          <Route path="/programas/laboratorio-de-incidencia" element={<Site><Laboratorio /></Site>} />
          <Route path="/donaciones/informes-de-resultados" element={<Site><Informes /></Site>} />
          <Route path="/conocenos/informes-de-resultados" element={<Site><Informes /></Site>} />
          <Route path="/red-de-clubs/como-abrir-un-club" element={<Site><ComoAbrirClub /></Site>} />
          <Route path="/recursos/faqs" element={<Site><Faqs /></Site>} />
          <Route
            path="/recursos/para-clubs"
            element={<Site><RecursosArchive category="para-clubs" title="Para Clubs" intro="Recursos exclusivos para acompañar la gestión de tu club y tus proyectos." requirePassword groups={[{ value: "gestion-interna", label: "Gestión interna del Club" }, { value: "proyectos-iniciativas", label: "Recursos para proyectos e iniciativas" }, { value: "gestion-finanzas", label: "Gestión de Finanzas" }]} /></Site>}
          />
          <Route
            path="/recursos/protocolos-de-seguridad"
            element={<Site><RecursosArchive category="protocolos-de-seguridad" title="Protocolos de Seguridad" intro="Protocolos para prevenir y actuar frente a situaciones de riesgo o violencia." accentKey="magenta" /></Site>}
          />
          <Route
            path="/recursos/guias-de-lenguaje"
            element={<Site><RecursosArchive category="guias-de-lenguaje" title="Guías prácticas de DDHH" intro="Guías para usar un lenguaje incluyente y respetuoso en nuestros espacios y materiales." accentKey="magenta" /></Site>}
          />
          <Route path="/red-de-clubs/transicion-de-liderazgos" element={<Site><TransicionLiderazgos /></Site>} />
          <Route path="/red-de-clubs/directorio-de-clubs" element={<Site><DirectorioClubs /></Site>} />
          <Route path="/programas/programa-de-acompanamiento" element={<Site><ProgramaAcompanamiento /></Site>} />
          <Route path="/programas/clubs" element={<Site><ClubsPrograma /></Site>} />
          <Route path="/donaciones/dona-ahora" element={<Site><DonaAhora /></Site>} />
          <Route path="/programas/tejiendo-redes-ciudadanas" element={<Site><TejiendoRedes /></Site>} />
          <Route path="/programas/el-jardin" element={<Site><ElJardin /></Site>} />
          <Route path="/conocenos/nuestros-consejos" element={<Site><NuestrosConsejos /></Site>} />
          <Route path="/conocenos/nuestros-consejos/juvenil/:slug" element={<Site><EquipoDetail /></Site>} />
          <Route path="/conocenos/nuestros-consejos/equipo/:slug" element={<Site><EquipoDetail /></Site>} />
          <Route path="/conocenos/nuestros-consejos/:slug" element={<Site><EquipoDetail /></Site>} />
          {SECTIONS.filter((s) => s.subpages.length > 0).map((s) => (
            <Route key={s.key}>
              <Route path={s.path} element={<Site><SectionPage sectionKey={s.key} /></Site>} />
              <Route
                path={`${s.path}/:slug`}
                element={<Site><SubPage sectionKey={s.key} /></Site>}
              />
            </Route>
          ))}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
